import React from 'react';
import ContentCourseErrorRateSummary from './ContentCourseErrorRateSummary';
import { ContentCourseErrorRateListService } from '../../services/ContentListService';
import { observer } from 'mobx-react';

const ContentCourseErrorRateSummaryContainer = () => {
  const summary = ContentCourseErrorRateListService.getChart();
  return (
    <ContentCourseErrorRateSummary
      isLoading={
        ContentCourseErrorRateListService.fetchCurrent.fetching ||
        ContentCourseErrorRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentCourseErrorRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentCourseErrorRateSummaryContainer);
